import { render } from "./Event-Component.vue?vue&type=template&id=70a4fe1f"
import script from "./Event-Component.vue?vue&type=script&lang=js"
export * from "./Event-Component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__